import React from 'react'
import ColorContainer from './ColorContainer'

const Color = props => <ColorContainer data-test="component-configurator-design-color" {...props} />

export default Color
